// src/i18n.ts
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import dashboardEN from "./common/json/dashboard/en/translation.json"
import dashboardBN from "./common/json/dashboard/bn/translation.json"
import monitoringEN from "./common/json/monitoring/en/translation.json"
import monitoringBN from "./common/json/monitoring/bn/translation.json"
import employeesEN from "./common/json/employees/en/translation.json"
import employeesBN from "./common/json/employees/bn/translation.json"
import deviceEN from "./common/json/device/en/translation.json"
import deviceBN from "./common/json/device/bn/translation.json"
import manageAccountEN from "./common/json/manageAccount/en/translation.json"
import manageAccountBN from "./common/json/manageAccount/bn/translation.json"
import settingsEN from "./common/json/settings/en/translation.json"
import settingsBN from "./common/json/settings/bn/translation.json"
import utiltyEN from "./common/json/utilty/en/translation.json"
import utiltyBN from "./common/json/utilty/bn/translation.json"
import projectManagementEN from "./common/json/projectManagement/en/translation.json"
import projectManagementBN from "./common/json/projectManagement/bn/translation.json"
import reportsManagementEN from "./common/json/reports/en/translation.json"
import reportsManagementBN from "./common/json/reports/bn/translation.json"
import supportEN from "./common/json/support/en/translation.json"
import supportBN from "./common/json/support/bn/translation.json"
import organizationEN from "./common/json/organization/en/translation.json"
import organizationBN from "./common/json/organization/bn/translation.json"
import layoutEN from "./common/json/layout/en/translation.json"
import layoutBN from "./common/json/layout/bn/translation.json"
import configurationEN from "./common/json/configuration/en/translation.json"
import configurationBN from "./common/json/configuration/bn/translation.json"
import aiChatEN from "./common/json/aiChat/en/translation.json"
import aiChatBN from "./common/json/aiChat/bn/translation.json"
import timeTrackingEN from "./common/json/timeTracking/en/translation.json"
import timeTrackingBN from "./common/json/timeTracking/bn/translation.json"

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        dashboard: dashboardEN,
        monitoring: monitoringEN,
        employees: employeesEN,
        device: deviceEN,
        manageAccount:manageAccountEN,
        settings: settingsEN,
        utilty:utiltyEN,
        projectManagement: projectManagementEN,
        reports: reportsManagementEN,
        support: supportEN,
        organization: organizationEN,
        layout: layoutEN,
        configuration: configurationEN,
        aiChat: aiChatEN,
        timeTracking: timeTrackingEN,
      },
      bn: {
        dashboard: dashboardBN,
        monitoring: monitoringBN,
        employees: employeesBN,
        device: deviceBN,
        manageAccount:manageAccountBN,
        settings: settingsBN,
        utilty:utiltyBN,
        projectManagement: projectManagementBN,
        reports: reportsManagementBN,
        support: supportBN,
        organization: organizationBN,
        layout: layoutBN,
        configuration: configurationBN,
        aiChat: aiChatBN,
        timeTracking: timeTrackingBN,
      }
    },
    fallbackLng: 'en',
    ns: ['dashboard', 'monitoring', 'employees', 'device', 'manageAccount', 'settings', 'utilty', 'projectManagement', 'reports', 'support', 'organization', 'layout', 'configuration', 'aiChat', 'timeTracking'],
    defaultNS: 'dashboard',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;